import React, {Component} from 'react'
import { DragLayer } from 'react-dnd'
import snapToGrid from './snapToGrid'

const layerStyles = {
	position: 'fixed',
	pointerEvents: 'none',
	zIndex: '100',
	left: '0',
	top: '0',
	width: '100%',
	height: '100%',
}

function getItemStyles(props) {
	const { initialOffset, currentOffset } = props
	if (!initialOffset || !currentOffset) {
		return {
			display: 'none',
		}
	}

	let { x, y } = currentOffset

	if (props.snapToGrid) {
		x -= initialOffset.x
		y -= initialOffset.y
		;[x, y] = snapToGrid(x, y)
		x += initialOffset.x
		y += initialOffset.y
	}

	const transform = `translate(${x}px, ${y}px)`
	return {
		transform,
		WebkitTransform: transform,
	}
}

class CustomDragLayer extends Component {
    renderItem() {
        const { item, itemType } = this.props
		
		switch (itemType) {
			case 'box':
				return(
					<div style={{position:'absolute',backgroundColor:'#ADD8E6',border:'1px dashed blue',padding:'0.5rem 1rem',cursor:'move',opacity:'0.2'}}>
						{item.title}
					</div>
				)
			default:
				return null
		}
	}

    render() {
        const { isDragging } = this.props
		
        if (!isDragging) {
            return null
        }
        return (
            <div style={layerStyles}>
                <div style={getItemStyles(this.props)}>{this.renderItem()}</div>
            </div>
        )
    }
}

function collect(monitor) {
	return {
		item: monitor.getItem(),
		itemType: monitor.getItemType(),
		initialOffset: monitor.getInitialSourceClientOffset(),
		currentOffset: monitor.getSourceClientOffset(),
		isDragging: monitor.isDragging(),
	};
}

export default DragLayer(collect)(CustomDragLayer);


// WEBPACK FOOTER //
// ./src/view/print/paperconfig/CustomDragLayer.js